import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
    { label: "Assets", href: "#assets" },
    { label: "Holding Company", href: "#holding" },
    { label: "The Plan", href: "#plan" },
    { label: "Enquiry", href: "#enquiry" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    return (
        <header
            data-testid="site-navbar"
            className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-md border-b border-white/10"
        >
            <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
                <a href="#top" data-testid="nav-brand-link" className="flex items-center gap-3">
                    <span className="w-8 h-8 bg-amber-500 flex items-center justify-center font-display font-bold text-black text-lg">
                        GV
                    </span>
                    <span className="font-display font-semibold tracking-wide text-lg text-white">
                        LEGACY GV VENTURES
                    </span>
                </a>
                <nav className="hidden md:flex items-center gap-8">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="text-sm text-slate-300 hover:text-amber-500 transition-colors duration-200"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href="#enquiry"
                        data-testid="nav-cta-button"
                        className="bg-amber-500 text-black text-sm font-semibold px-5 py-2 rounded-full hover:bg-amber-400 transition-colors duration-200"
                    >
                        Partner With Us
                    </a>
                </nav>
                <button
                    data-testid="nav-mobile-toggle"
                    className="md:hidden text-white"
                    onClick={() => setOpen(!open)}
                    aria-label="Toggle menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>
            {open && (
                <nav className="md:hidden border-t border-white/10 bg-black/90 px-6 py-4 flex flex-col gap-4">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            onClick={() => setOpen(false)}
                            className="text-sm text-slate-300 hover:text-amber-500 transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
            )}
        </header>
    );
}
